module.exports = __webpack_public_path__ + "img/fact_bg4.9d35d48e.png";